import React from 'react';

const Loader = () => {
  return (
    <div style={containerStyle}>
      <div className="vastu-loader" style={loaderStyle}>
        <div style={innerCircleStyle}></div>
        <div style={compassNeedleStyle}></div>
      </div>
      <p style={textStyle}>Loading Vastu Insights...</p>
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0% { transform: scale(0.8); opacity: 0.5; }
          50% { transform: scale(1.1); opacity: 1; }
          100% { transform: scale(0.8); opacity: 0.5; }
        }
      `}</style>
    </div>
  );
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '60vh', // Takes up significant vertical space
  width: '100%',
  backgroundColor: 'transparent'
};

const loaderStyle = {
  width: '80px',
  height: '80px',
  border: '4px solid var(--color-border)',
  borderTop: '4px solid var(--color-secondary)',
  borderRadius: '50%',
  position: 'relative',
  animation: 'spin 1.5s linear infinite',
  marginBottom: '1.5rem',
  boxShadow: '0 0 15px rgba(218, 165, 32, 0.2)'
};

const innerCircleStyle = {
  width: '40px',
  height: '40px',
  backgroundColor: 'var(--color-bg-secondary)',
  borderRadius: '50%',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  border: '2px dashed var(--color-secondary)'
};

const compassNeedleStyle = {
  width: '4px',
  height: '30px',
  backgroundColor: 'var(--color-primary)',
  position: 'absolute',
  top: '15%',
  left: '50%',
  transform: 'translateX(-50%)',
  borderRadius: '2px'
};

const textStyle = {
  color: 'var(--color-secondary-dark)',
  fontWeight: '600',
  letterSpacing: '1px',
  animation: 'pulse 2s ease-in-out infinite'
};

export default Loader;
